import { render, staticRenderFns } from "./ClientOwnersAndFamilyCard.vue?vue&type=template&id=71d233e7&"
import script from "./ClientOwnersAndFamilyCard.vue?vue&type=script&lang=js&"
export * from "./ClientOwnersAndFamilyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports